import React, { useEffect, useState, useMemo } from 'react'
import InpatientPage from './InpatientPage'
import { FaComment } from 'react-icons/fa'
import { HiOutlineDocumentDownload } from 'react-icons/hi'
import './style.css'
import axios from 'axios'
import { useLocation } from 'react-router-dom'
import ChatModal from './tab-components/ChatModal'
import DocumentModal from './tab-components/DocumentModal'
import { toast } from 'react-toastify'
import { useAuth } from '../../modules/auth'
import { useNavigate } from 'react-router-dom'
import Pusher from 'pusher-js'
import { CreateAppModal } from '../../../_metronic/partials/modals/request-fgl-stepper/CreateAppModal'
import { saveAs } from 'file-saver'
import { debounce } from 'lodash'
import { setGlobalAttention } from '../../../_metronic/layout/components/header/Header'
import { useClaimAttention } from '../../../hooks/useClaimAttention'
import { usePageData } from '../../../_metronic/layout/core/PageData'
import { Modal } from 'react-bootstrap'
import { IoIosClose } from 'react-icons/io'
import { LuDownload } from 'react-icons/lu'
import { useClaimDetails } from '../../../hooks/useClaims'
import { parseJsonObject } from '../../../utils/parseJsonObject'

interface DocumentStatus {
  status: string
  id: number
  name: string
  isArchive: boolean
}

interface DiagnosisData {
  mainDiagnosis?: string
  supportingDiagnosis?: string
  supportingDiagnosis3?: string
  supportingDiagnosis4?: string
  icd1?: string
  icd2?: string
  icd3?: string
  icd4?: string
  doctor?: string
  polyName?: string
  remark?: string
  deposit?: string
  rencanaTindakan?: string
  losEstimation?: string
  originalIcdCodes?: {
    icd1?: string
    icd2?: string
    icd3?: string
    icd4?: string
  }
  indate?: string
}

const InpatientPageWrapper: React.FC = () => {
  const user = useAuth()
  const { auth } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  console.log('location', location)
  const [claimDetails, setClaimDetails] = useState<{ claimDetails: any } | null>(
    location.state as { claimDetails: any }
  )
  console.log('claimDetails', claimDetails)
  const [isLoading, setIsLoading] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [remark, setRemark] = useState('')
  const [showRemarkError, setShowRemarkError] = useState(false)
  const [isConfirmCancel, setIsConfirmCancel] = useState(false)
  const [activeKey, setActiveKey] = useState<string>('diagnosis')
  const [validationData, setValidationData] = useState<any>(null)
  const [isDataValid, setIsDataValid] = useState<boolean>(false)
  const [isEditingDiagnosis, setIsEditingDiagnosis] = useState<boolean>(false)
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false)
  const [chatMessage, setChatMessage] = useState<string>('')
  const [currentView, setCurrentView] = useState<
    'inpatient' | 'calendar' | 'dailyMonitoringDetail' | 'discharged'
  >('inpatient')
  const [status, setStatus] = useState<string>(claimDetails?.claimDetails?.status || '')
  // const [status, setStatus] = useState<string>(claimDetails.claim.status)
  const [showFGLModal, setShowFGLModal] = useState<boolean>(false)
  const [formattedDate, setFormattedDate] = useState<string>(new Date().toISOString().split('T')[0])
  const [incomingsinglefile, setIncomingsinglefile] = useState<any>(null)
  const [documentsUploaded, setDocumentsUploaded] = useState<boolean>(false)
  const [diagnosisFieldsFilled, setDiagnosisFieldsFilled] = useState<boolean>(false)
  const [documentsUploadedNew, setDocumentsUploadedNew] = useState<boolean>(false)
  const [notificationCount, setNotificationCount] = useState(0)
  const [hasNewNotification, setHasNewNotification] = useState(false)
  const [isFromDailyMonitoring, setIsFromDailyMonitoring] = useState<boolean>(false)
  const [documentRealtime, setDocumentRealtime] = useState<any>(null)
  const [view, setView] = useState<string>('inpatient')
  const [loading, setLoading] = useState<boolean>(false)
  const jsonString = claimDetails?.claimDetails?.detailBenefit
  const parsedJson = parseJsonObject(jsonString)
  const jsonString2 = claimDetails?.claimDetails?.claimData
  const parsedJson2 = jsonString2 ? JSON.parse(jsonString2) : {}
  const [isReupload, setIsReupload] = useState<boolean>(false)
  const [documentsStatus, setDocumentsStatus] = useState<{
    hasInvalid: boolean
    allUploaded: boolean
  }>({
    hasInvalid: false,
    allUploaded: false,
  })

  console.log('claimDetails', claimDetails)

  const {
    data: dataClaimDetails,
    refetch: refetchDetailsClaim
  } = useClaimDetails(claimDetails?.claimDetails?.claimNumber, true)

  // Guard clause - return early if no claimDetails
  if (!claimDetails?.claimDetails) {
    return <div>No claim details available</div>
  }

  // Update claimDetails when location state changes
  useEffect(() => {
    if (location.state) {
      console.log('Location state changed, updating claimDetails:', location.state)
      setClaimDetails(location.state as { claimDetails: any })
    }
  }, [location.state])

  // Update status when claimDetails changes
  useEffect(() => {
    if (claimDetails?.claimDetails?.status) {
      setStatus(claimDetails.claimDetails.status)
    }
  }, [claimDetails])

  // Add new state to track document statuses
  const [documentStatuses, setDocumentStatuses] = useState<{
    [key: string]: { status: string; id: number; name: string; isArchive: boolean }
  }>({})

  console.log('documentStatuses', documentStatuses)

  // Add new state to track last notification
  const [lastNotification, setLastNotification] = useState<{
    label: string
    status: string
    timestamp: number
  } | null>(null)

  // Add this state at the top with other state declarations
  const [lastToastTime, setLastToastTime] = useState<number>(0)

  // Add new state for button
  const [isButtonEnabled, setIsButtonEnabled] = useState<boolean>(false)
  const [isAttentionEnabled, setIsAttentionEnabled] = useState<boolean>(false)

  // Add state for diagnosis validation
  const [isDiagnosisValid, setIsDiagnosisValid] = useState<boolean>(false)

  // Add state for editing
  const [isEditing, setIsEditing] = useState<boolean>(false)

  // Add new state for diagnosis data
  const [diagnosisData, setDiagnosisData] = useState<DiagnosisData>({})

  const { addClaimNumber, removeClaimNumber } = usePageData()

  // Add this state if not already present
  const [isChatModalOpen, setIsChatModalOpen] = useState<boolean>(false)

  // Add new state for documentsData
  const [documentsData, setDocumentsData] = useState<any[]>([])

  // Add new state for current status
  const [currentStatus, setCurrentStatus] = useState<string>(
    claimDetails?.claimDetails?.status || ''
  )

  // Add new state for IGL Superseding Request modal
  const [showSupersedingModal, setShowSupersedingModal] = useState<boolean>(false)
  const [supersedingRemark, setSupersedingRemark] = useState<string>('')
  const [showSupersedingRemarkError, setShowSupersedingRemarkError] = useState<boolean>(false)
  const [currentSupersedingType, setCurrentSupersedingType] = useState<string>('')

  // Add defaultDocuments constant
  const defaultDocuments = [
    { label: 'Lembar Medis Awal', key: 0 },
    { label: 'Copy KTP Pasien', key: 1 },
    { label: 'Copy Kartu Asuransi Pasien', key: 2 },
    { label: 'Surat Pernyataan (SP)', key: 3 },
    { label: 'Medical Inquiry', key: 4 },
    { label: 'Hasil Penunjang', key: 5 },
  ]

  // Add handler for diagnosis data changes
  const handleDiagnosisDataChange = (newData: Partial<DiagnosisData>) => {
    const updatedData = {
      ...diagnosisData,
      ...newData,
      originalIcdCodes: {
        ...diagnosisData.originalIcdCodes,
        icd1: newData.icd1 || diagnosisData.originalIcdCodes?.icd1,
        icd2: newData.icd2 || diagnosisData.originalIcdCodes?.icd2,
        icd3: newData.icd3 || diagnosisData.originalIcdCodes?.icd3,
        icd4: newData.icd4 || diagnosisData.originalIcdCodes?.icd4,
      },
    }

    setDiagnosisData(updatedData)

    // Immediately validate the updated data
    const isValid = validateDiagnosisFields(updatedData)
    setIsDiagnosisValid(isValid)

    console.log('Diagnosis Validation:', {
      data: updatedData,
      isValid,
      fields: {
        mainDiagnosis: !!updatedData.mainDiagnosis?.trim(),
        icd1: !!(updatedData.originalIcdCodes?.icd1?.trim() || updatedData.icd1?.trim()),
        doctor: !!updatedData.doctor?.trim(),
        polyName: !!updatedData.polyName?.trim(),
        rencanaTindakan: !!updatedData.rencanaTindakan?.trim(),
      },
    })
  }

  // Update validateDiagnosisFields to be more explicit
  const validateDiagnosisFields = (data: DiagnosisData): boolean => {
    if (!data) return false

    const isValid = !!(
      (
        data.mainDiagnosis?.trim() &&
        data.doctor?.trim() &&
        data.polyName?.trim() &&
        data.rencanaTindakan?.trim()
      )
      // data.losEstimation?.trim() &&
      // data.deposit?.trim()
    )

    return isValid
  }

  const debouncedFetch = debounce(async () => {
    await checkDocumentStatuses()
  }, 1000) // 1 second delay

  useEffect(() => {
    if (status === 'Registered' || status === 'Pre-Registered' || status === 'Pre-Auth') {
      setIsEditingDiagnosis(true)
    } else {
      setIsEditingDiagnosis(false)
    }
  }, [status])

  const handleDocumentsStatusChange = (status: boolean) => {
    console.log('Documents status changed:', status)
    setDocumentsUploaded(status)
    setIsDataValid(status)
    setIsAttentionEnabled(status)

    // Immediately update button state
    const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL', 'Pre-Auth'].includes(
      claimDetails.claimDetails.status
    )
    const shouldEnable = status && isDiagnosisValid && validStatus
    console.log('shouldEnable: ', shouldEnable)
    console.log('shouldEnable: ', {
      status,
      isDiagnosisValid,
      validStatus,
    })
    setIsButtonEnabled(shouldEnable)
    setShouldEnableButton(shouldEnable)
    // setShouldEnableButton(false)
    setGlobalAttention(shouldEnable, claimDetails.claimDetails.claimNumber)
  }

  const handleDocumentRealtimeUpdate = (data: any) => {
    console.log('Document realtime update received:', data)
    if (data.isSuccess) {
      const apiDocuments = data.data.filter((doc: any) => doc.label !== 'Prescription')

      // Check document statuses - IDLE should be considered acceptable
      const hasInvalidDocuments = apiDocuments.some(
        (doc: any) =>
          doc.document &&
          doc.document.length > 0 &&
          doc.document.some(
            (file: any) => file.status === 'INVALID' || file.status === 'Request Document'
          )
      )

      const allDocumentsUploaded = defaultDocuments.every((defaultDoc) =>
        apiDocuments.some(
          (apiDoc) =>
            apiDoc.label === defaultDoc.label && apiDoc.document && apiDoc.document.length > 0
        )
      )

      // Check if all documents have acceptable status (not INVALID or Request Document)
      const allDocumentsValidStatus = apiDocuments.every(
        (doc: any) =>
          doc.document &&
          doc.document.length > 0 &&
          doc.document.every(
            (file: any) => file.status !== 'INVALID' && file.status !== 'Request Document'
          )
      )

      // Update states immediately
      const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL', 'Pre-Auth'].includes(
        status
      )
      const shouldEnable =
        allDocumentsUploaded &&
        !hasInvalidDocuments &&
        allDocumentsValidStatus &&
        isDiagnosisValid &&
        validStatus

      setDocumentsUploaded(allDocumentsUploaded)
      setIsDataValid(!hasInvalidDocuments)
      setIsButtonEnabled(shouldEnable)
      setShouldEnableButton(shouldEnable)
      setIsAttentionEnabled(shouldEnable)
      setGlobalAttention(shouldEnable, claimDetails.claimDetails.claimNumber)

      console.log('Real-time button state update:', {
        allDocumentsUploaded,
        hasInvalidDocuments,
        allDocumentsValidStatus,
        isDiagnosisValid,
        validStatus,
        shouldEnable,
      })
    }
  }

  // const handleDocumentRealtimeUpdate = (data: any) => {
  //   console.log('Document realtime update received:', data)
  //   if (data.isSuccess) {
  //     const apiDocuments = data.data.filter((doc: any) => doc.label !== 'Prescription')

  //     // Check document statuses
  //     const hasInvalidDocuments = apiDocuments.some(
  //       (doc: any) =>
  //         doc.document &&
  //         doc.document.length > 0 &&
  //         doc.document.some((file: any) => file.status === 'INVALID')
  //     )

  //     const allDocumentsUploaded = defaultDocuments.every((defaultDoc) =>
  //       apiDocuments.some(
  //         (apiDoc) =>
  //           apiDoc.label === defaultDoc.label && apiDoc.document && apiDoc.document.length > 0
  //       )
  //     )

  //     const allDocumentsIdle = apiDocuments.every(
  //       (doc: any) =>
  //         doc.document &&
  //         doc.document.length > 0 &&
  //         doc.document.every(
  //           (file: any) => file.status === 'IDLE' || file.status === 'Request Document'
  //         )
  //     )

  //     // Update states
  //     const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(
  //       claimDetails.claimDetails.status
  //     )
  //     const shouldEnable =
  //       allDocumentsUploaded &&
  //       !hasInvalidDocuments &&
  //       allDocumentsIdle &&
  //       isDiagnosisValid &&
  //       validStatus

  //     setDocumentsUploaded(allDocumentsUploaded)
  //     setIsDataValid(!hasInvalidDocuments)
  //     setIsButtonEnabled(shouldEnable)
  //     setShouldEnableButton(shouldEnable)
  //     setIsAttentionEnabled(shouldEnable)
  //     setGlobalAttention(shouldEnable, claimDetails.claimDetails.claimNumber)
  //   }
  // }

  console.log('isReupload', isReupload)

  useEffect(() => {
    console.log('inpatient page wrapper')
    console.log('isReupload', isReupload)
    const fetchDataDischarge = async () => {
      const claimNumber = claimDetails.claimDetails.claimNumber
      const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}?area=Discharge`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        if (response.data.isSuccess) {
          setDocumentsData(response.data.data)
          // setIsReupload(false)
        } else {
          console.error('Failed to fetch documents:', response.data.message)
          // setIsReupload(false)
        }
      } catch (error) {
        console.error('Error fetching documents:', error)
        // setIsReupload(false)
      }
    }

    fetchDataDischarge()
  }, [isReupload === true])

  useEffect(() => {
    console.log('inpatient page wrapper')
    const fetchDataDischarge = async () => {
      const claimNumber = claimDetails.claimDetails.claimNumber
      const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}?area=Discharge`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        if (response.data.isSuccess) {
          setDocumentsData(response.data.data)
        } else {
          console.error('Failed to fetch documents:', response.data.message)
        }
      } catch (error) {
        console.error('Error fetching documents:', error)
      }
    }

    fetchDataDischarge()
  }, [claimDetails])

  useEffect(() => {
    console.log('inpatient page wrapper')
    const fetchData = async () => {
      const claimNumber = claimDetails.claimDetails.claimNumber
      const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        if (response.data.isSuccess) {
          setValidationData(response.data.data)
          validateDocuments(response.data.data)
        } else {
          console.error('Failed to fetch documents:', response.data.message)
        }
      } catch (error) {
        console.error('Error fetching documents:', error)
      }
    }

    fetchData()
  }, [claimDetails])

  useEffect(() => {
    // console.log("Current View: ", currentView);
  }, [currentView])

  const validateDocuments = (data: any[]) => {
    // Filter out Prescription documents first
    const relevantDocuments = data.filter((doc) => doc.label !== 'Prescription')

    // Check if any document has INVALID status
    const hasInvalidDocuments = relevantDocuments.some(
      (doc) =>
        doc.document &&
        doc.document.length > 0 &&
        doc.document.some((file) => file.status === 'INVALID' || file.status === 'Request Document')
    )

    // Check if all required documents are present and uploaded
    const requiredLabels = [
      'Lembar Medis Awal',
      'Copy KTP Pasien',
      'Copy Kartu Asuransi Pasien',
      'Surat Pernyataan (SP)',
      'Medical Inquiry',
      'Hasil Penunjang',
      'Surat Keterangan Hak Kamar',
    ]

    const hasAllDocuments = requiredLabels.every((label) =>
      relevantDocuments.some(
        (item) => item.label === label && item.document && item.document.length > 0
      )
    )

    // console.log("Has Invalid Documents:", hasInvalidDocuments);
    // console.log("Has All Documents:", hasAllDocuments);

    // Only set documentsUploaded to true if all documents are present AND none are invalid
    setDocumentsUploaded(hasAllDocuments && !hasInvalidDocuments)
    setIsDataValid(hasAllDocuments && !hasInvalidDocuments)
  }

  const handleEditClick = () => {
    setIsEditingDiagnosis(true)
  }

  const handleDocumentClick = (docLabel: string) => {
    setChatMessage(docLabel)
    setIsChatOpen(true)
  }

  const handleRequestIGL = async (e: React.FormEvent) => {
    e.preventDefault()

    if (status !== 'Pre-Registered' && status !== 'Pending on IGL' && status !== 'Pre-Auth') {
      return
    }

    // Disable attention message immediately
    setIsAttentionEnabled(false)
    setGlobalAttention(false, claimDetails.claimDetails.claimNumber, status)

    setLoading(true)
    try {
      if (status === 'Pre-Registered' || status === 'Pre-Auth') {
        if (parsedJson?.Deposit) {
          await updateClaimStatus()
        } else {
          await saveDiagnosisData()
          await updateClaimStatus()
        }
        navigate('/builder')
      } else if (status === 'Pending on IGL') {
        await updateClaimStatus()
        navigate('/builder')
      }
    } catch (error) {
      console.error('Error in handleRequestIGL:', error)
      handleError(error)
      // Re-enable attention on error
      setIsAttentionEnabled(true)
      setGlobalAttention(true, claimDetails.claimDetails.claimNumber, status)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { }, [diagnosisData])

  // Helper function to save diagnosis data
  const saveDiagnosisData = async () => {
    const existingData = claimDetails.claimDetails.claimData
    const parsedExistingData = existingData ? JSON.parse(existingData) : {}

    const depositStr = diagnosisData.deposit || parsedExistingData?.Deposit || '0'
    const depositValue = parseFloat(depositStr.replace(/\./g, '').replace(/,/g, '.'))

    const payload = {
      claimNo: claimDetails?.claimDetails?.claimNumber,
      icdCode1: diagnosisData.originalIcdCodes?.icd1 || parsedJson2?.IcdCode1 || '',
      icdCode2: diagnosisData.originalIcdCodes?.icd2 || parsedJson2?.IcdCode2 || '',
      icdCode3: diagnosisData.originalIcdCodes?.icd3 || parsedJson2?.IcdCode3 || '',
      icdCode4: diagnosisData.originalIcdCodes?.icd4 || parsedJson2.icdCode4 || '',
      doctor: diagnosisData.doctor || parsedExistingData?.Doctor || '',
      polyName: diagnosisData.polyName || parsedExistingData?.PolyName || '',
      remark: diagnosisData.remark || parsedExistingData?.Remark || '',
      deposit: depositValue,
      treatmentPlan: diagnosisData.rencanaTindakan || parsedExistingData?.TreatmentPlan || '',
      los: diagnosisData.losEstimation
        ? parseInt(diagnosisData.losEstimation)
        : parseInt(parsedExistingData?.Los) || 0,
      updatedBy: user.currentUser?.email,
      indate:
        diagnosisData.indate !== undefined
          ? diagnosisData.indate
          : claimDetails?.claimDetails?.indate || '',
      BenefitDetail: {
        id: parsedJson?.Id,
        benefitName: parsedJson?.BenefitName,
        planName: parsedJson?.PlanName,
        benefitCode: parsedJson?.BenefitCode,
        condition: parsedJson?.Condition,
        annualLimit: parsedJson?.AnnualLimit,
        subBenefits:
          parsedJson?.SubBenefits?.map((subBenefit: any) => ({
            id: subBenefit.Id,
            category: 'INPATIENT',
            SubBenefitName: subBenefit.SubBenefitName,
            isCashless: subBenefit.IsCashless,
            isReimburstement: subBenefit.IsReimburstement,
            annualLimit: subBenefit.AnnualLimit,
            type: subBenefit.Type,
            claimValue: subBenefit.ClaimValue,
            details: subBenefit.Details,
            condition: subBenefit?.Condition || [],
            isAsCharge: subBenefit.IsAsCharge,
          })) || [],
      },
    }

    // console.log('Payload:', JSON.stringify(payload, null, 2));

    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/Provider/ProcessClaim/INPATIENT`,
      payload,
      { headers }
    )

    if (!response.data.isSuccess) {
      throw new Error('Failed to save diagnosis data')
    }

    toast.success('IGL Request submitted successfully!', {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: 'light',
    })

    setIsEditing(false)
  }

  // Helper function to update claim status
  const updateClaimStatus = async () => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimDetails.claimDetails.claimNumber,
      status: 'Request IGL',
      username: user.currentUser?.email,
      source: 'Provider',
    }
    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    const response = await axios.post(apiUrl, payload, { headers })

    if (!response.data.isSuccess) {
      throw new Error('Failed to submit IGL Request')
    }

    toast.success('IGL Request submitted successfully!', {
      position: 'bottom-right',
      autoClose: 3000,
    })
  }

  const updateClaimStatusSupersedingRequest = async (
    status: string,
    remark: string = 'Superseding Request'
  ) => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimDetails.claimDetails.claimNumber,
      status:
        status === 'IGL' || status === 'Daily Monitoring'
          ? 'IGL Superseding Request'
          : 'FGL Superseding Request',
      username: user.currentUser?.email,
      source: 'Provider',
      remarkSuperseeding: remark,
    }
    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    const response = await axios.post(apiUrl, payload, { headers })

    if (!response.data.isSuccess) {
      throw new Error('Failed to submit IGL Request')
    }

    toast.success('IGL Request submitted successfully!', {
      position: 'bottom-right',
      autoClose: 3000,
    })
  }

  const updateClaimStatusFGLReviewWhenPending = async () => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimDetails.claimDetails.claimNumber,
      status: 'FGL Review',
      username: user.currentUser?.email,
      source: 'Provider',
    }
    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    const response = await axios.post(apiUrl, payload, { headers })

    if (!response.data.isSuccess) {
      throw new Error('Failed to submit IGL Request')
    }

    toast.success('FGL Review submitted successfully!', {
      position: 'bottom-right',
      autoClose: 3000,
    })
    navigate('/builder')
  }

  // Helper function to handle errors
  const handleError = (error: any) => {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred'

    toast.error(errorMessage, {
      position: 'bottom-right',
      autoClose: 3000,
    })
  }

  // Update initial view and active key based on status
  useEffect(() => {
    if (
      status === 'FGL RELEASED' ||
      status === 'FGL Released' ||
      status === 'Request FGL' ||
      status === 'Final Document Complete' ||
      status === 'FGL Review' ||
      status === 'Pending on FGL'
    ) {
      setCurrentView('discharged')
      setView('discharged')
      setActiveKey('discharged')
    }
  }, [status])

  // Update the visibility conditions for prev/next buttons
  const showPrevButton =
    status === 'FGL RELEASED' ||
    status === 'FGL Released' ||
    status === 'Request FGL' ||
    status === 'Final Document Complete' ||
    status === 'FGL Review' ||
    status === 'Pending on FGL' ||
    ((status === 'IGL RELEASED' || status === 'Daily Monitoring' || status === 'IGL Released') &&
      currentView === 'calendar')

  const showNextButton =
    // Show next button on inpatient view for FGL statuses
    ((status === 'FGL RELEASED' ||
      status === 'FGL Released' ||
      status === 'Request FGL' ||
      status === 'Final Document Complete' ||
      status === 'FGL Review' ||
      status === 'Pending on FGL') &&
      currentView === 'inpatient') ||
    // Show next button for IGL/Daily Monitoring statuses on inpatient
    ((status === 'IGL RELEASED' || status === 'Daily Monitoring' || status === 'IGL Released') &&
      currentView === 'inpatient') ||
    // Show next button on calendar view for FGL statuses
    ((status === 'FGL RELEASED' ||
      status === 'FGL Released' ||
      status === 'Request FGL' ||
      status === 'Final Document Complete' ||
      status === 'FGL Review' ||
      status === 'Pending on FGL') &&
      currentView === 'calendar')

  // Update the navigation handler
  const handleViewNavigation = (direction: 'prev' | 'next') => {
    if (
      status === 'FGL RELEASED' ||
      status === 'FGL Released' ||
      status === 'Request FGL' ||
      status === 'Final Document Complete' ||
      status === 'FGL Review' ||
      status === 'Pending on FGL'
    ) {
      if (currentView === 'discharged') {
        if (direction === 'prev') {
          setCurrentView('calendar')
          setView('calendar')
          setActiveKey('calendar')
        }
      } else if (currentView === 'calendar') {
        if (direction === 'prev') {
          setCurrentView('inpatient')
          setView('inpatient')
          setActiveKey('diagnosis')
        } else if (direction === 'next') {
          setCurrentView('discharged')
          setView('discharged')
          setActiveKey('discharged')
        }
      } else if (currentView === 'inpatient') {
        if (direction === 'next') {
          setCurrentView('calendar')
          setView('calendar')
          setActiveKey('calendar')
        }
      }
    } else if (
      status === 'IGL RELEASED' ||
      status === 'Daily Monitoring' ||
      status === 'IGL Released'
    ) {
      if (direction === 'next') {
        setCurrentView('calendar')
        setView('calendar')
        setActiveKey('calendar')
      } else if (direction === 'prev') {
        setCurrentView('inpatient')
        setView('inpatient')
        setActiveKey('diagnosis')
      }
    }
  }

  useEffect(() => {
    if (status === 'Request IGL') {
      // console.log('View changed to:', view);
      if (view === 'calendar') {
        setActiveKey('calendar')
      } else if (view === 'inpatient') {
        setActiveKey('diagnosis')
      }
    } else if (status === 'Request FGL') {
      if (view === 'discharged') {
        setActiveKey('discharged')
      }
    }
  }, [view, status])

  useEffect(() => {
    // console.log('View changed to:', currentView);
  }, [currentView])

  useEffect(() => {
    const pusher = new Pusher(`${process.env.REACT_APP_API_PUSHER_KEY!}`, {
      cluster: process.env.REACT_APP_API_PUSHER_CLUSTER! || 'ap1',
      forceTLS: true,
    })

    const claimNumber = claimDetails.claimDetails.claimNumber

    // Subscribe to list-file-channel
    const listFileChannel = pusher.subscribe(`list-file-channel-${claimNumber}`)

    // Subscribe to file-channel-{claimNumber}
    const fileStatusChannel = pusher.subscribe(`file-channel-${claimNumber}`)

    console.log('fileStatusChannel', fileStatusChannel)

    // Handle list-file updates
    listFileChannel.bind(`get-list-${claimNumber}`, (data: any) => {
      // console.log("Received list file data:", data);
      setDocumentRealtime(data)

      if (data.isSuccess) {
        const apiDocuments = data.data.filter((doc: any) => doc.label !== 'Prescription')

        // Update states as before
        const newDocumentStatuses = { ...documentStatuses }
        apiDocuments.forEach((doc: any) => {
          if (doc.document?.[0]) {
            newDocumentStatuses[doc.label] = {
              status: doc.document[0].status,
              id: doc.document[0].id,
              name: doc.document[0].name,
              isArchive: doc.document[0].isArchive,
            }
          }
        })
        setDocumentStatuses(newDocumentStatuses)
      }
    })

    // Handle individual file status updates
    fileStatusChannel.bind(`get-${claimNumber}`, (data: any) => {
      if (data && data.message) {
        const { message } = data
        const { Label, Status, Id, DocumentName, isArchive, UpdatedBy } = message

        // Update document statuses
        setDocumentStatuses((prev) => {
          const newStatuses = {
            ...prev,
            [Label]: {
              status: Status,
              id: Id,
              name: DocumentName,
              isArchive: isArchive,
            },
          }

          // Check required documents
          const requiredLabels = [
            'Lembar Medis Awal',
            'Copy KTP Pasien',
            'Copy Kartu Asuransi Pasien',
            'Surat Pernyataan (SP)',
            'Surat Keterangan Hak Kamar',
            // 'Medical Inquiry',
            // 'Hasil Penunjang',
            'Resume Medis',
            'Billing Akhir',
            // 'Hasil Penunjang',
          ]

          // Check if any document has INVALID status
          const hasInvalidDocuments = Object.values(newStatuses).some(
            (doc: any) => doc.status === 'INVALID' || doc.status === 'Request Document'
          )

          console.log('hasInvalidDocuments', hasInvalidDocuments)

          // Check if all required documents are uploaded (regardless of status)
          const allRequiredUploaded = requiredLabels.every(
            (label) => newStatuses[label] !== undefined
          )

          // Update states immediately
          setDocumentsUploaded(allRequiredUploaded)
          setIsDataValid(!hasInvalidDocuments)

          return newStatuses
        })

        // Handle toast notifications with debouncing
        const now = Date.now()
        if (Status === 'INVALID' || (Status === 'Request Document' && now - lastToastTime > 5000)) {
          // Clear any existing toasts first
          toast.dismiss()

          toast.error(`${Label} has been rejected by ${UpdatedBy}. Please review and resubmit.`, {
            position: 'top-right',
            autoClose: 3000,
          })
          setLastToastTime(now)
        }
      }
    })

    // Debug subscriptions
    // console.log("Subscribed to channels:", {
    //   listChannel: `list-file-channel-${claimNumber}`,
    //   fileChannel: `file-channel-${claimNumber}`,
    //   fileEvent: `get-${claimNumber}`
    // });

    return () => {
      listFileChannel.unbind_all()
      fileStatusChannel.unbind_all()
      pusher.unsubscribe(`list-file-channel-${claimNumber}`)
      pusher.unsubscribe(`file-channel-${claimNumber}`)
    }
  }, [claimDetails.claimDetails.claimNumber, documentStatuses, lastToastTime])

  // Add debug logging
  useEffect(() => {
    const checkAndUpdateDocuments = async () => {
      if (documentStatuses && typeof documentStatuses === 'object') {
        // Check if any document has INVALID status
        const hasInvalidStatus = Object.values(documentStatuses).some(
          (doc: DocumentStatus) =>
            doc.status === 'INVALID' || doc.status === 'IDLE' || doc.status === 'Request Document'
        )

        // console.log("Document Status Check:", {
        //   currentStatus: documentStatuses,
        //   hasInvalidStatus,
        //   documentDetails: Object.entries(documentStatuses).map(([label, doc]) => ({
        //     label,
        //     status: doc.status
        //   })),
        //   timestamp: new Date().toISOString()
        // });

        // Only trigger fetch if status is changing to INVALID or IDLE
        const statusChanged = Object.values(documentStatuses).some(
          (doc) =>
            doc.status === 'INVALID' || doc.status === 'IDLE' || doc.status === 'Request Document'
        )

        if (statusChanged) {
          debouncedFetch()
        }
      }
    }

    checkAndUpdateDocuments()
    setIncomingsinglefile(documentStatuses)

    // console.log("Current document statuses:", documentStatuses);

    // Cleanup
    return () => {
      debouncedFetch.cancel()
    }
  }, [documentStatuses]) // Remove isDataValid and documentsStatus from dependencies

  useEffect(() => {
    // console.log("Component re-rendered. Current notification count:", notificationCount, "New notification:", hasNewNotification);
  }, [notificationCount, hasNewNotification])

  // Set default view based on status
  useEffect(() => {
    // if (status === 'IGL RELEASED') {
    //   setCurrentView('inpatient')
    //   setActiveKey('diagnosis')
    // } else if (status === 'Daily Monitoring') {
    //   setCurrentView('calendar')
    //   setActiveKey('calendar')
    // }
    if (status === 'IGL RELEASED' || status === 'IGL Released' || status === 'Daily Monitoring') {
      setCurrentView('calendar')
      setActiveKey('calendar')
    }
  }, [status])

  const isMonitoringOrFGL = status === 'Daily Monitoring' || status === 'Request FGL'

  const tabStyle = {
    cursor: 'pointer',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
    backgroundColor: 'white',
  }

  const activeTabStyle = {
    backgroundColor: 'rgba(243, 245, 247, 1)',
    color: '#000',
  }

  const handleDocumentsClick = () => {
    setIsChatOpen(true)
  }

  const checkDocumentStatuses = async () => {
    const claimNumber = claimDetails.claimDetails.claimNumber
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}`

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
        },
      })

      if (response.data.isSuccess) {
        const documents = response.data.data

        // Check if all required documents are uploaded
        const requiredLabels = [
          'Lembar Medis Awal',
          'Copy KTP Pasien',
          'Copy Kartu Asuransi Pasien',
          'Surat Pernyataan (SP)',
          'Medical Inquiry',
          'Hasil Penunjang',
          'Surat Keterangan Hak Kamar',
        ]

        const allUploaded = requiredLabels.every((label) => {
          const doc = documents.find((d: any) => d.label === label)
          return doc && doc.document && doc.document.length > 0
        })

        // Check if any document has INVALID status
        const hasInvalid = documents.some((doc: any) => {
          // Skip Prescription documents
          if (doc.label === 'Prescription') return false

          return (
            doc.document &&
            doc.document.length > 0 &&
            doc.document.some(
              (file: any) =>
                file.status === 'INVALID' ||
                file.status === 'Request Document' ||
                file.status === 'REQUEST'
            )
          )
        })

        setDocumentsStatus({
          hasInvalid,
          allUploaded,
        })

        // console.log('Document Status Check:', {
        //   allUploaded,
        //   hasInvalid,
        //   documents: documents.map((d: any) => ({
        //     label: d.label,
        //     status: d.document?.[0]?.status
        //   }))
        // });
      }
    } catch (error) {
      console.error('Error checking document statuses:', error)
    }
  }

  useEffect(() => {
    if (['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)) {
      checkDocumentStatuses()
    }
  }, [status])

  const canRequestIGL = useMemo(() => {
    // Check if there are required documents (explicitly filter out Prescription)
    const relevantDocuments = documentRealtime?.message?.Data?.filter(
      (doc: any) => doc.Label !== 'Prescription'
    )

    // Check if we have all 6 required documents
    const hasAllRequiredDocuments = relevantDocuments?.length >= 4

    const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)
    const validDocuments =
      hasAllRequiredDocuments && documentsUploaded && !documentsStatus.hasInvalid

    return isDataValid && validStatus && validDocuments
  }, [
    documentRealtime?.message?.Data,
    status,
    documentsUploaded,
    documentsStatus.hasInvalid,
    isDataValid,
  ])

  const getRequestIGLWarnings = (): string[] => {
    const warnings: string[] = []

    // Helper function to safely check values
    const isValidValue = (value: any): boolean => {
      if (value === null || value === undefined) return false
      if (typeof value === 'number') return true
      if (typeof value === 'string') return value.trim().length > 0
      return false
    }

    // Check diagnosis data first
    const diagnosisFields = {
      'Diagnosa Utama': diagnosisData?.mainDiagnosis,
      'Nama Dokter': diagnosisData?.doctor,
      'Nama Poli': diagnosisData?.polyName,
      'Rencana Tindakan': diagnosisData?.rencanaTindakan,
      // 'Rencana Lama Rawat Inap': diagnosisData?.losEstimation,
      // Deposit: diagnosisData?.deposit,
    }

    const missingFields = Object.entries(diagnosisFields)
      .filter(([_, value]) => !isValidValue(value))
      .map(([field]) => field)

    if (missingFields.length > 0) {
      warnings.push(...missingFields)
    }

    // Check documents
    if (!documentsUploaded) {
      const missingDocs: string[] = []
      const invalidDocs: string[] = []
      const requiredLabels = [
        'Lembar Medis Awal',
        'Copy KTP Pasien',
        'Copy Kartu Asuransi Pasien',
        'Surat Pernyataan (SP)',
        'Medical Inquiry',
        'Hasil Penunjang',
        'Surat Keterangan Hak Kamar',
      ]

      if (validationData) {
        // Filter out Prescription documents before validation
        const filteredValidationData = validationData.filter(
          (doc: any) => doc.label !== 'Prescription'
        )

        filteredValidationData.forEach((doc: any) => {
          if (requiredLabels.includes(doc.label)) {
            if (!doc.document || doc.document.length === 0) {
              missingDocs.push(doc.label)
            } else if (doc.document?.some((file: any) => file.status === 'INVALID')) {
              invalidDocs.push(doc.label)
            }
          }
        })
      }

      if (missingDocs.length > 0) {
        warnings.push(...missingDocs)
      }
      if (invalidDocs.length > 0) {
        warnings.push(...invalidDocs)
      }
    }

    return warnings
  }

  const handleDownloadIGL = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_CLAIM_URL}/api/Attachment/DownloadIGL/${claimDetails.claimDetails.claimNumber}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        }
      )

      if (!response.ok) {
        throw new Error('Failed to fetch IGL document')
      }

      const data = await response.json()

      if (data && data.url) {
        // Open URL in new tab to trigger download
        window.open(data.url, '_blank')

        toast.success('IGL download started!', {
          position: 'top-right',
          autoClose: 3000,
        })
      } else {
        throw new Error('Invalid response format')
      }
    } catch (error) {
      console.error('Error downloading IGL:', error)
      toast.error('Failed to download IGL', {
        position: 'top-right',
        autoClose: 3000,
      })
    }
  }

  const handleDownloadFGL = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_CLAIM_URL}/api/Attachment/DownloadFGL/${claimDetails.claimDetails.claimNumber}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        }
      )

      if (!response.ok) {
        throw new Error('Failed to fetch FGL document')
      }

      const data = await response.json()

      if (data && data.url) {
        // Open URL in new tab to trigger download
        window.open(data.url, '_blank')

        toast.success('FGL download started!', {
          position: 'top-right',
          autoClose: 3000,
        })
      } else {
        throw new Error('Invalid response format')
      }
    } catch (error) {
      console.error('Error downloading FGL:', error)
      toast.error('Failed to download FGL', {
        position: 'top-right',
        autoClose: 3000,
      })
    }
  }

  // console.log('Document Realtime:', JSON.stringify(documentRealtime, null, 2));

  useEffect(() => {
    if (documentRealtime?.message?.IsSuccess) {
      // Filter out Prescription documents
      const apiDocuments = documentRealtime.message.Data.filter(
        (doc: any) => doc.Label !== 'Prescription'
      )

      // Create status objects for each document
      const documentStatuses = apiDocuments.map((doc) => ({
        label: doc.Label,
        status: doc.Document?.[0]?.Status || 'NO_DOCUMENT',
        hasDocument: Boolean(doc.Document && doc.Document.length > 0),
      }))

      // Define required document labels (explicitly exclude Prescription)
      const requiredLabels = [
        'Lembar Medis Awal',
        'Copy KTP Pasien',
        'Copy Kartu Asuransi Pasien',
        'Surat Pernyataan (SP)',
        'Medical Inquiry',
        'Hasil Penunjang',
        'Surat Keterangan Hak Kamar',
      ]

      // Check if any required document has INVALID status - IDLE should be considered acceptable
      const hasInvalidDocuments = documentStatuses
        .filter((doc) => requiredLabels.includes(doc.label))
        .some((doc) => doc.status === 'INVALID' || doc.status === 'Request Document')

      // Check if all required documents are uploaded
      const allDocumentsUploaded = requiredLabels.every((label) =>
        documentStatuses.some((doc) => doc.label === label && doc.hasDocument)
      )

      setDocumentsUploaded(allDocumentsUploaded)
      setIsDataValid(!hasInvalidDocuments)

      // Calculate button state - consider IDLE as acceptable status along with VALID
      const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)
      const shouldEnableButton =
        validStatus && allDocumentsUploaded && !hasInvalidDocuments && isDiagnosisValid

      setIsButtonEnabled(shouldEnableButton)
      if (status === 'Pending on IGL') {
        setIsAttentionEnabled(shouldEnableButton)
        setGlobalAttention(shouldEnableButton, claimDetails.claimDetails.claimNumber, status)
      } else {
        setIsAttentionEnabled(shouldEnableButton)
        setGlobalAttention(shouldEnableButton, claimDetails.claimDetails.claimNumber, status)
      }

      // console.log('Button State Calculation:', {
      //   validStatus,
      //   allDocumentsUploaded,
      //   hasInvalidDocuments,
      //   isDiagnosisValid,
      //   shouldEnableButton,
      //   currentTime: new Date().toISOString()
      // });
    }
  }, [documentRealtime, status, isDiagnosisValid])

  // Add another useEffect to handle diagnosis-only validation
  useEffect(() => {
    const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)
    const shouldEnableButton =
      validStatus && documentsStatus.allUploaded && !documentsStatus.hasInvalid && isDiagnosisValid

    setIsButtonEnabled(shouldEnableButton)
    if (status === 'Pending on IGL') {
      setIsAttentionEnabled(shouldEnableButton)
      setGlobalAttention(shouldEnableButton, claimDetails.claimDetails.claimNumber, status)
    } else {
      setIsAttentionEnabled(shouldEnableButton)
      setGlobalAttention(shouldEnableButton, claimDetails.claimDetails.claimNumber, status)
    }
  }, [isDiagnosisValid, status, documentsStatus])

  // Add this state at the top with other states
  const [shouldEnableButton, setShouldEnableButton] = useState<boolean>(false)

  // Update the useEffect for button state
  useEffect(() => {
    console.log('documentRealtime: ', documentRealtime)
    const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL', 'Pre-Auth'].includes(
      status
    )
    // Filter out Prescription documents before checking length
    const relevantDocuments = documentRealtime?.message?.Data?.filter(
      (doc: any) => doc.Label !== 'Prescription'
    )

    // Check if any document has invalid status (Request Document or INVALID)
    const hasInvalidStatusDocuments =
      documentRealtime?.message?.Data?.some((docGroup: any) =>
        docGroup.Document?.some(
          (doc: any) => doc.Status === 'Request Document' || doc.Status === 'INVALID'
        )
      ) || false

    console.log('hasInvalidStatusDocuments: ', hasInvalidStatusDocuments)
    // Check count of relevant documents only (excluding Prescription)
    const hasDocuments = relevantDocuments?.length >= 4

    // Consider documents valid if they are uploaded and don't have problematic statuses
    // IDLE status should be considered acceptable along with VALID
    const validDocuments =
      hasDocuments && documentsUploaded && !documentsStatus.hasInvalid && !hasInvalidStatusDocuments

    console.log('ShouldEnableButton: ', {
      validDocuments,
      validStatus,
      hasDocuments,
      documentsUploaded,
      documentsStatus,
      hasInvalidStatusDocuments,
    })
    // Button state only depends on documents and status
    setShouldEnableButton(validStatus && validDocuments)
  }, [
    status,
    documentRealtime?.message?.Data,
    documentsUploaded,
    documentsStatus.hasInvalid,
    isDiagnosisValid,
    diagnosisData,
  ])

  const canRequestFGL = useMemo(() => {
    console.log('documentsData: ', documentsData)
    // Check if documentsData is defined and is an array
    if (!Array.isArray(documentsData)) return false

    // Log the entire documentsData for debugging
    // console.log("Documents Data: ", documentsData);

    // Check for the "Resume Medis", "Billing Akhir", and "Hasil Penunjang" labels
    const resumeMedisDoc = documentsData.find((doc) => doc.label === 'Resume Medis')
    const billingAkhirDoc = documentsData.find((doc) => doc.label === 'Billing Akhir')
    const hasilPenunjangDoc = documentsData.find((doc) => doc.label === 'Hasil Penunjang')

    // Log the found documents for debugging
    // console.log("Resume Medis Document: ", resumeMedisDoc);
    // console.log("Billing Akhir Document: ", billingAkhirDoc);
    // console.log("Hasil Penunjang Document: ", hasilPenunjangDoc);

    // Check if there are any documents with status "INVALID" or "Request Document" in documentsData
    const hasInvalidDocumentsData = documentsData.some(
      (doc) =>
        doc.document &&
        doc.document.some((file) => file.status === 'INVALID' || file.status === 'Request Document')
    )

    // Check if there are any documents with status "INVALID" in documentStatuses
    const hasInvalidDocumentStatuses = Object.values(documentStatuses).some(
      (doc: any) => doc.status === 'INVALID' || doc.status === 'Request Document'
    )

    // Combined check for invalid documents
    const hasInvalidDocuments = hasInvalidDocumentsData || hasInvalidDocumentStatuses

    // Enable the button if there are no invalid documents and all required documents are uploaded
    return (
      !hasInvalidDocuments &&
      resumeMedisDoc &&
      resumeMedisDoc.document.length > 0 &&
      billingAkhirDoc &&
      billingAkhirDoc.document.length > 0 &&
      hasilPenunjangDoc &&
      hasilPenunjangDoc.document.length > 0
    )
  }, [documentsData, documentStatuses])

  const handleRequestFGL = () => {
    if (status === 'Pending on FGL') {
      updateClaimStatus()
    } else if (status === 'Daily Monitoring') {
      setShowFGLModal(true)
    }
  }

  // Add handler for status updates
  const handleStatusUpdate = (newStatus: string) => {
    setCurrentStatus(newStatus)
  }

  const handleSave = async (e: React.FormEvent) => {
    console.log('parsedJson', parsedJson)
    e.preventDefault()
    // console.log("Diagnosis Data Wrapper : ", diagnosisData);
    setLoading(true)
    try {
      const existingData = claimDetails?.claimDetails?.claimData
      const parsedExistingData = existingData ? JSON.parse(existingData) : {}

      const depositStr = diagnosisData.deposit || parsedExistingData.deposit || '0'
      const depositValue = parseFloat(depositStr.replace(/\./g, '').replace(/,/g, '.'))

      const payload = {
        claimNo: claimDetails?.claimDetails?.claimNumber,
        icdCode1: diagnosisData?.originalIcdCodes?.icd1 || parsedJson2?.IcdCode1 || '',
        icdCode2: diagnosisData?.originalIcdCodes?.icd2 || parsedJson2?.IcdCode2 || '',
        icdCode3: diagnosisData?.originalIcdCodes?.icd3 || parsedJson2?.IcdCode3 || '',
        icdCode4: diagnosisData.originalIcdCodes?.icd4 || parsedJson2.icdCode4 || '',
        doctor: diagnosisData.doctor || parsedExistingData.doctor || '',
        polyName: diagnosisData.polyName || parsedExistingData.polyName || '',
        remark: diagnosisData.remark || parsedExistingData.remark || '',
        deposit: depositValue,
        treatmentPlan: diagnosisData.rencanaTindakan || parsedExistingData.rencanaTindakan || '',
        los: diagnosisData.losEstimation
          ? parseInt(diagnosisData.losEstimation)
          : parseInt(parsedExistingData.los) || 0,
        updatedBy: user.currentUser?.email,
        BenefitDetail: {
          id: parsedJson?.Id,
          benefitName: parsedJson?.BenefitName,
          planName: parsedJson?.PlanName,
          benefitCode: parsedJson?.BenefitCode,
          condition: parsedJson?.Condition,
          annualLimit: parsedJson?.AnnualLimit,
          subBenefits:
            parsedJson?.SubBenefits?.map((subBenefit: any) => ({
              id: subBenefit.Id,
              category: 'INPATIENT',
              SubBenefitName: subBenefit.SubBenefitName,
              isCashless: subBenefit.IsCashless,
              isReimburstement: subBenefit.IsReimburstement,
              annualLimit: subBenefit.AnnualLimit,
              type: subBenefit.Type,
              claimValue: subBenefit.ClaimValue,
              details: subBenefit.Details,
              condition: subBenefit?.Condition || [],
              isAsCharge: subBenefit.IsAsCharge,
            })) || [],
        },
        indate:
          diagnosisData.indate !== undefined
            ? diagnosisData.indate
            : claimDetails?.claimDetails?.indate || '',
      }

      // console.log('Payload:', JSON.stringify(payload, null, 2));

      const headers = {
        Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/Provider/ProcessClaim/INPATIENT`,
        payload,
        { headers }
      )

      if (response.data.isSuccess) {
        toast.success('Successfully saved as draft!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'light',
          onOpen: () => {
            // console.log('Toast opened');
          },
        })
        setIsEditing(false)
      } else {
        toast.error('Failed to save diagnosis data')
      }
    } catch (error: any) {
      console.error('Error saving diagnosis data:', error)
      toast.error(error.response?.data?.message || 'Error saving diagnosis data')
    }
  }

  const handleCancel = () => {
    // Your cancel logic here
    setIsEditing(false)
  }

  // Add handler for edit
  const handleEdit = () => {
    setIsEditing(true)
  }

  useEffect(() => {
    if (claimDetails?.claimDetails?.claimNumber) {
      const claimNumber = claimDetails.claimDetails.claimNumber
      addClaimNumber(claimNumber)

      return () => {
        removeClaimNumber(claimNumber)
      }
    }
  }, [claimDetails])

  const updateClaimStatusVoid = async (claimNumber: string, remark: string) => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimNumber,
      status: 'Void',
      username: user.currentUser?.email,
      source: 'Provider',
      remarkRejectVoid: remark,
    }
    const headers = {
      Authorization: `Bearer ${user.currentUser?.token}`,
    }

    try {
      const response = await axios.post(apiUrl, payload, { headers })

      if (!response.data.isSuccess) {
        throw new Error('Failed to submit IGL Request')
      }

      toast.success('Update claim status successfully!', {
        position: 'bottom-right',
        autoClose: 3000,
      })

      // Refetch data after successful update
      setIsLoading(true)
      navigate('/builder')
    } catch (error) {
      console.error('Error updating claim status:', error)
      toast.error('Failed to update claim status', {
        position: 'bottom-right',
        autoClose: 3000,
      })
    }
  }

  const downloadDeclineLetter = async () => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Attachment/DownloadDL/${claimDetails?.claimDetails?.claimNumber}`
    const headers = {
      Authorization: `Bearer ${user.currentUser?.token}`,
    }
    try {
      const response = await axios.get(apiUrl, { headers })
      console.log('response: ', response)

      // Handle new response format with URL object
      if (response.data && response.data.url) {
        const downloadUrl = response.data.url
        const fileName = response.data.name
          ? response.data.name.split('/').pop()
          : `${claimDetails?.claimDetails?.claimNumber}${response.data.extention || '.pdf'}`

        // Create a temporary anchor element to download from the signed URL
        const a = document.createElement('a')
        a.href = downloadUrl
        a.download = fileName
        a.target = '_blank'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } else {
        // Fallback to old method if response format is different
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${claimDetails?.claimDetails?.claimNumber}.pdf`
        a.click()
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      console.error('Error downloading decline letter:', error)
      toast.error('Failed to download decline letter', {
        position: 'top-right',
        autoClose: 3000,
      })
    }
  }

  const handleCancelClick = () => {
    setShowCancelModal(true)
  }

  const handleModalClose = () => {
    setShowCancelModal(false)
    setRemark('')
    setIsConfirmCancel(false)
  }

  const handleConfirmCancel = () => {
    if (!remark.trim()) {
      setShowRemarkError(true)
      return
    }
    updateClaimStatusVoid(claimDetails?.claimDetails?.claimNumber, remark)
    handleModalClose()
    setRemark('')
    setShowRemarkError(false)
  }

  // Add handlers for Superseding Request modal
  const handleSupersedingClick = (type: string) => {
    setCurrentSupersedingType(type)
    setShowSupersedingModal(true)
  }

  const handleSupersedingModalClose = () => {
    setShowSupersedingModal(false)
    setSupersedingRemark('')
    setShowSupersedingRemarkError(false)
    setCurrentSupersedingType('')
  }

  const handleConfirmSuperseding = async () => {
    if (!supersedingRemark.trim()) {
      setShowSupersedingRemarkError(true)
      return
    }

    try {
      await updateClaimStatusSupersedingRequest(currentSupersedingType, supersedingRemark)
      handleSupersedingModalClose()
      navigate('/builder')
    } catch (error) {
      console.error('Error submitting superseding request:', error)
      toast.error('Failed to submit superseding request', {
        position: 'bottom-right',
        autoClose: 3000,
      })
    }
  }

  return (
    <>
      <div className='card card-custom gutter-b' style={{ marginTop: '-50px' }}>
        <div className='frame-header'>
          <div className='frame-headertop'>
            <div className='frame-menu2'>
              <span className='frame-text36'>{claimDetails.claimDetails.claimNumber}</span>
              <div className='frame-row25'>
                <div className='frame-label20'>
                  <span className='frame-text37'>Rawat Inap</span>
                </div>
              </div>
            </div>
            <div className='frame-row26'>
              <div
                className={
                  currentStatus.toLowerCase() === 'pending data'
                    ? 'frame-statuslabel'
                    : currentStatus.toLowerCase() === 'daily monitoring'
                      ? 'frame-statuslabel-1'
                      : 'frame-statuslabel-2'
                }
              >
                <span
                  className={
                    currentStatus.toLowerCase() === 'pending data'
                      ? 'frame-text38'
                      : currentStatus.toLowerCase() === 'daily monitoring'
                        ? 'frame-text42'
                        : 'frame-text45'
                  }
                >
                  {currentStatus}
                </span>
              </div>
            </div>
            <div className='frame-row26'>
              {/* Add chat icon button here */}
              <button
                className='btn btn-icon btn-active-light-primary'
                onClick={() => setIsChatModalOpen(true)}
                style={{
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer',
                  padding: '5px',
                  marginRight: '-95%',
                }}
              >
                <FaComment size={20} color='#059BB6' />

                {/* Red Dot */}
                {dataClaimDetails?.chatCounter > 0 && (
                  <span
                    style={{
                      position: 'absolute',
                      top: '4px',
                      right: '2px',
                      minWidth: '12px',
                      height: '14px',
                      backgroundColor: 'red',
                      color: 'white',
                      borderRadius: '50%',
                      fontSize: '10px',
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '0 4px',
                      lineHeight: 1,
                    }}
                  >
                    {dataClaimDetails?.chatCounter}
                  </span>
                )}
              </button>
            </div>
          </div>
          <div className='frame-headerhelper'>
            <div className='frame-row29'>
              <span className='frame-text39'>Patient Name</span>
              <span className='frame-text40'>{claimDetails.claimDetails.memberName}</span>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                position: 'relative',
                gap: '6px',
              }}
            >
              <button
                className='frame-button19'
                onClick={() => handleViewNavigation('prev')}
                style={{
                  visibility: showPrevButton && currentView !== 'inpatient' ? 'visible' : 'hidden',
                  cursor: 'pointer',
                  border: 'none',
                  background: 'none',
                  padding: '4px',
                  color: '#7E8299',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <svg
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M15 19L8 12L15 5'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </button>
              <div
                className='frame-indicator1'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <span className='frame-text41'>
                  {status === 'Request FGL' ||
                    status === 'FGL RELEASED' ||
                    status === 'FGL Released' ||
                    status === 'Final Document Complete' ||
                    status === 'FGL Review' ||
                    status === 'Pending on FGL'
                    ? currentView === 'discharged'
                      ? 'DISCHARGED'
                      : currentView === 'calendar'
                        ? 'Daily Monitoring'
                        : 'Admission'
                    : currentView === 'inpatient'
                      ? 'Admission'
                      : 'Daily Monitoring'}
                </span>
              </div>
              <button
                className='frame-button19'
                onClick={() => handleViewNavigation('next')}
                style={{
                  visibility: showNextButton ? 'visible' : 'hidden',
                  cursor: 'pointer',
                  border: 'none',
                  background: 'none',
                  padding: '4px',
                  color: '#7E8299',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <svg
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M9 5L16 12L9 19'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </button>
            </div>
            <div className='frame-row30'>
              <div className='frame-row31'>
                <div
                  className='frame-igl'
                  style={{ display: 'flex', gap: '10px', alignItems: 'center' }}
                >
                  {status === 'Reject' && (
                    <button
                      className='btn btn-danger cursor-pointer'
                      style={{ fontSize: '12px', padding: '0.75rem 1.5rem' }}
                      onClick={downloadDeclineLetter}
                    >
                      <LuDownload style={{ fontSize: '16px', marginRight: '4px' }} />
                      DL
                    </button>
                  )}
                  {((status !== 'Void' && status === 'Pre-Registered') ||
                    status === 'Pre-Auth') && (
                      <button
                        className='btn btn-danger cursor-pointer'
                        style={{ fontSize: '12px', padding: '0.75rem 1.5rem' }}
                        onClick={handleCancelClick}
                      >
                        Void
                      </button>
                    )}
                  {(status === 'Pre-Registered' ||
                    status === 'Pending on IGL' ||
                    status === 'Pre-Auth' ||
                    isEditingDiagnosis) && (
                      <button
                        type='submit'
                        className='frame-button11'
                        style={{
                          backgroundColor: '#127289',
                          color: 'white',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                          cursor: 'pointer',
                        }}
                        onClick={handleSave}
                      >
                        <span className='frame-text27 Body500Md'>Save As Draft</span>
                      </button>
                    )}

                  {/* {status === "Daily Monitoring" && (
                    <button
                      type="button"
                      className="frame-button11"
                      style={{
                        backgroundColor: '#127289',
                        color: 'white',
                        border: 'none',
                        borderRadius: '0.475rem',
                        padding: '0.75rem 1.5rem',
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        setCurrentView('calendar');
                        setView('calendar');
                        setActiveKey('calendar');
                        setTimeout(() => {
                          setCurrentView('calendar');
                        }, 0);
                      }}
                    >
                      <span className="frame-text27 Body500Md">Back</span>
                    </button>
                  )} */}

                  {/* {status === "Daily Monitoring" && (
                    <button
                      type="button"
                      className="frame-button11"
                      style={{
                        backgroundColor: '#059BB6',
                        color: 'white',
                        border: 'none',
                        borderRadius: '0.475rem',
                        padding: '0.75rem 1.5rem',
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        setCurrentView('calendar');
                        setView('calendar');
                        setActiveKey('calendar');
                        setTimeout(() => {
                          setCurrentView('calendar');
                        }, 0);
                      }}
                    >
                      <span className="frame-text27 Body500Md">Back</span>
                    </button>
                  )} */}

                  {status === 'IGL RELEASED' || status === 'IGL Released' ? (
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#127289',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleDownloadIGL}
                      >
                        <HiOutlineDocumentDownload size={16} />
                        <span className='frame-text42 Body500Md'>IGL</span>
                      </button>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#2A9D8F',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={() => handleSupersedingClick('IGL')}
                      >
                        <span className='frame-text42 Body500Md'>IGL Superseding Request</span>
                      </button>
                    </div>
                  ) : status === 'FGL RELEASED' || status === 'FGL Released' ? (
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#127289',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleDownloadIGL}
                      >
                        <HiOutlineDocumentDownload size={16} />
                        <span className='frame-text42 Body500Md'>IGL</span>
                      </button>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#127289',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleDownloadFGL}
                      >
                        <HiOutlineDocumentDownload size={16} />
                        <span className='frame-text42 Body500Md'>FGL</span>
                      </button>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#2A9D8F',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={() => handleSupersedingClick('FGL')}
                      >
                        <span className='frame-text42 Body500Md'>FGL Superseding Request</span>
                      </button>
                    </div>
                  ) : status === 'Registered' ||
                    status === 'Pre-Registered' ||
                    status === 'Pre-Auth' ||
                    status === 'Pending on IGL' ? (
                    <div className='tooltip-container' style={{ position: 'relative' }}>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: shouldEnableButton ? '#127289' : '#E4E6EF',
                          color: 'white',
                          cursor: shouldEnableButton ? 'pointer' : 'not-allowed',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                          transition: 'background-color 0.3s ease',
                        }}
                        onClick={handleRequestIGL}
                        disabled={!shouldEnableButton}
                        onMouseEnter={(e) => {
                          const tooltip = e.currentTarget.parentElement?.querySelector('.tooltip')
                          if (tooltip) {
                            tooltip.classList.add('visible')
                          }
                        }}
                        onMouseLeave={(e) => {
                          const tooltip = e.currentTarget.parentElement?.querySelector('.tooltip')
                          if (tooltip) {
                            tooltip.classList.remove('visible')
                          }
                        }}
                      >
                        <span className='frame-text42 Body500Md'>Request IGL</span>
                      </button>
                      {!shouldEnableButton && (
                        <div
                          className='tooltip'
                          style={{
                            position: 'absolute',
                            top: '45px',
                            right: '0px',
                            backgroundColor: 'white',
                            padding: '12px 16px',
                            borderRadius: '6px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            width: '320px',
                            maxWidth: 'calc(100vw - 40px)',
                            zIndex: 1000,
                            border: '1px solid #e9ecef',
                            opacity: 0,
                            visibility: 'hidden',
                            transition: 'opacity 0.2s, visibility 0.2s',
                          }}
                        >
                          <div
                            style={{
                              fontSize: '13px',
                              color: '#495057',
                              marginBottom: '12px',
                              fontWeight: 500,
                              borderBottom: '1px solid #e9ecef',
                              paddingBottom: '8px',
                            }}
                          >
                            Please complete the following requirements:
                          </div>
                          <ul
                            style={{
                              margin: 0,
                              padding: '0 0 0 20px',
                              fontSize: '12px',
                              color: '#6c757d',
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '8px',
                            }}
                          >
                            {getRequestIGLWarnings().map((warning, index) => (
                              <li
                                key={index}
                                style={{
                                  lineHeight: '1.4',
                                  position: 'relative',
                                }}
                              >
                                {warning.includes(':') ? (
                                  <>
                                    {warning.split(':')[0]}:
                                    <span style={{ color: '#dc3545', marginLeft: '4px' }}>
                                      {warning.split(':')[1]}
                                    </span>
                                  </>
                                ) : (
                                  warning
                                )}
                                {warning.includes('Missing diagnosis fields') && (
                                  <ul
                                    style={{
                                      margin: '4px 0 0 0',
                                      padding: '0 0 0 20px',
                                      listStyle: 'none',
                                    }}
                                  >
                                    {warning
                                      .split(':')[1]
                                      .split(',')
                                      .map((field, i) => (
                                        <li
                                          key={i}
                                          style={{
                                            color: '#dc3545',
                                            fontSize: '11px',
                                            marginTop: '2px',
                                          }}
                                        >
                                          {field.trim()}
                                        </li>
                                      ))}
                                  </ul>
                                )}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  ) : status === 'Daily Monitoring' ? (
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#127289',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleDownloadIGL}
                      >
                        <HiOutlineDocumentDownload size={16} />
                        <span className='frame-text42 Body500Md'>IGL</span>
                      </button>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#127289',
                          color: 'white',
                          cursor: 'pointer',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleRequestFGL}
                        disabled={false}
                      >
                        <span className='frame-text42 Body500Md'>Request FGL</span>
                      </button>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#2A9D8F',
                          color: 'white',
                          cursor: 'pointer',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={() => handleSupersedingClick('Daily Monitoring')}
                      >
                        <span className='frame-text42 Body500Md'>Superseding Request</span>
                      </button>
                    </div>
                  ) : status === 'Pending on FGL' ? (
                    <button
                      className='frame-button20'
                      style={{
                        backgroundColor: canRequestFGL ? '#127289' : '#E4E6EF',
                        color: 'white',
                        cursor: canRequestFGL ? 'pointer' : 'not-allowed',
                        border: 'none',
                        borderRadius: '0.475rem',
                        padding: '0.75rem 1.5rem',
                      }}
                      onClick={updateClaimStatusFGLReviewWhenPending}
                      disabled={!canRequestFGL}
                    >
                      <span className='frame-text42 Body500Md'>Request FGL</span>
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
        <InpatientPage
          claimDetails={claimDetails}
          onDocumentsStatusChange={handleDocumentsStatusChange}
          isEditingDiagnosis={isEditingDiagnosis}
          onEditClick={handleEditClick}
          onDocumentClick={handleDocumentClick}
          onValidateDiagnosis={validateDiagnosisFields}
          isFromDailyMonitoring={isFromDailyMonitoring}
          onDiagnosisDataChange={handleDiagnosisDataChange}
          currentView={currentView}
          setIsReupload={setIsReupload}
          onDocumentRealtimeUpdate={handleDocumentRealtimeUpdate}
        />
      </div>

      {showFGLModal && (
        <CreateAppModal
          show={showFGLModal}
          handleClose={() => setShowFGLModal(false)}
          claimDetails={claimDetails}
          formattedDate={formattedDate}
          onSuccessSubmit={() => {
            setShowFGLModal(false)
            navigate('/builder')
          }}
        />
      )}
      <DocumentModal
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
        claimNumber={claimDetails.claimDetails.claimNumber}
        token={user.currentUser?.token}
      />
      {isChatModalOpen && claimDetails && (
        <ChatModal
          isOpen={isChatModalOpen}
          onClose={() => setIsChatModalOpen(false)}
          message=''
          claimDetails={claimDetails.claimDetails}
          onRefetchDetailsClaim={refetchDetailsClaim}
        />
      )}

      {/* Metronic Cancel Confirmation Modal */}
      <Modal
        id='kt_modal_cancel_claim'
        show={showCancelModal}
        onHide={handleModalClose}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        contentClassName='modal-content rounded'
      >
        <div className='modal-header pb-0 border-0 justify-content-end'>
          <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleModalClose}>
            <IoIosClose size={24} />
          </div>
        </div>

        <div className='modal-body scroll-y px-10 px-lg-15 pt-0 pb-15'>
          <div className='mb-13 text-center'>
            <h1 className='mb-3'>Confirmation of Claim Void</h1>
          </div>

          <div className='d-flex flex-column mb-8'>
            <div className='text-center mb-5'>
              <p className='text-gray-800 fs-6 fw-semibold'>
                Are you sure you want to void claim {claimDetails?.claimDetails?.claimNumber} on
                behalf of {claimDetails?.claimDetails?.memberName}?
              </p>
            </div>

            {isConfirmCancel && (
              <div className='form-group'>
                <label className='required fw-semibold fs-6 mb-2'>Remark</label>
                <textarea
                  className={`form-control ${showRemarkError ? 'is-invalid' : ''}`}
                  rows={3}
                  value={remark}
                  onChange={(e) => {
                    setRemark(e.target.value)
                    setShowRemarkError(false)
                  }}
                />
                {showRemarkError && <div className='invalid-feedback'>Remark is required</div>}
              </div>
            )}
          </div>

          <div className='d-flex flex-center flex-row-fluid pt-12'>
            <button type='reset' className='btn btn-light me-3' onClick={handleModalClose}>
              Cancel
            </button>

            {!isConfirmCancel && (
              <button
                type='button'
                className='btn btn-primary'
                onClick={() => setIsConfirmCancel(true)}
              >
                Confirm
              </button>
            )}

            {isConfirmCancel && (
              <button
                type='button'
                className='btn btn-primary'
                onClick={handleConfirmCancel}
                disabled={!remark.trim()}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </Modal>

      {/* IGL/FGL Superseding Request Modal */}
      <Modal
        id='kt_modal_superseding_request'
        show={showSupersedingModal}
        onHide={handleSupersedingModalClose}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        contentClassName='modal-content rounded'
      >
        <div className='modal-header pb-0 border-0 justify-content-end'>
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={handleSupersedingModalClose}
          >
            <IoIosClose size={24} />
          </div>
        </div>

        <div className='modal-body scroll-y px-10 px-lg-15 pt-0 pb-15'>
          <div className='mb-13 text-center'>
            <h1 className='mb-3'>{currentSupersedingType} Superseding Request</h1>
          </div>

          <div className='d-flex flex-column mb-8'>
            <div className='text-center mb-5'>
              <p className='text-gray-800 fs-6 fw-semibold'>
                Please provide a reason for the {currentSupersedingType} superseding request for
                claim {claimDetails?.claimDetails?.claimNumber} on behalf of{' '}
                {claimDetails?.claimDetails?.memberName}:
              </p>
            </div>

            <div className='form-group'>
              <label className='required fw-semibold fs-6 mb-2'>
                Reason for Superseding Request
              </label>
              <textarea
                className={`form-control ${showSupersedingRemarkError ? 'is-invalid' : ''}`}
                rows={4}
                value={supersedingRemark}
                onChange={(e) => {
                  setSupersedingRemark(e.target.value)
                  setShowSupersedingRemarkError(false)
                }}
                placeholder='Enter the reason for the superseding request...'
                style={{ resize: 'vertical', minHeight: '100px' }}
              />
              {showSupersedingRemarkError && (
                <div className='invalid-feedback'>Reason is required</div>
              )}
            </div>
          </div>

          <div className='d-flex flex-center flex-row-fluid pt-12'>
            <button
              type='reset'
              className='btn btn-light me-3'
              onClick={handleSupersedingModalClose}
            >
              Cancel
            </button>
            <button
              type='button'
              className='btn btn-primary'
              onClick={handleConfirmSuperseding}
              disabled={!supersedingRemark.trim()}
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal>

      <style>
        {`
          .tooltip-container:hover .tooltip {
            opacity: 1 !important;
            visibility: visible !important;
          }
          
          .tooltip.visible {
            opacity: 1 !important;
            visibility: visible !important;
          }
          
          .tooltip::before {
            content: '';
            position: absolute;
            bottom: -16px;
            right: 20px;
            transform: translateY(-50%) rotate(180deg);
            border-width: 8px 8px 0 8px;
            border-style: solid;
            border-color: #e9ecef transparent transparent transparent;
          }

          .tooltip li::before {
            
            color: #dc3545;
            font-weight: bold;
            display: inline-block;
            width: 1em;
            margin-left: -1em;
          }
        `}
      </style>
    </>
  )
}

export default InpatientPageWrapper
